module.exports = __webpack_public_path__ + "img/CellCycle-BRCA_SpatialResearch.8b9420ee.png";